import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-history-table',
  templateUrl: './history-table.component.html',
  styleUrls: ['./history-table.component.css', '../../../../assets/css/customer-list-table.css']
})
export class HistoryTableComponent implements OnInit, OnChanges {

  invHistoricalListDataSource = new MatTableDataSource();
  displayedColumns: string[];

  @Input() tableData;
  @Input() tableHeaders: string[];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.tableData != undefined && this.tableHeaders != undefined) {
      this.invHistoricalListDataSource.data = this.tableData;
      this.displayedColumns = this.tableHeaders;
    }
  }

}
